MarketReportsApp.Models.SelectedOrg = Backbone.Model.extend({
    url: function() {
        return '/api/reports/associations/orgs/' + MarketReportsApp.Variables.SelectedOrg
    }
});